import { InjectionToken } from '@angular/core';
import { LogFn as PinoLogFn } from 'pino';

/**
 * Pino v10 (and v9.8.0) introduced strict type checking for format strings.
 * This relaxed version allows the old behavior of passing multiple arguments
 * without placeholders, while still supporting Pino's structured logging.
 */
export interface LogFn {
    (...args: any[]): void;
}

export interface Logger {
    error: LogFn;
    warn: LogFn;
    info: LogFn;
    debug: LogFn;
}

export const LOGGER = new InjectionToken<Logger>('Logger instance');
